<nav class="agu-bottom-tabs" aria-label="Primary" [class.agu-bottom-tabs--hidden]="Hidden" (focusin)="OnFocusIn()">
    @for (module of Modules; track module.Key) {
        <button type="button" class="agu-bottom-tabs__tab" [class.agu-bottom-tabs__tab--on]="IsActive(module)" [attr.data-tone]="ToneOf(module)" [attr.aria-current]="IsActive(module) ? 'page' : null" (click)="Select(module)">
            @if (module.IconName) {
                <agu-icon [Name]="module.IconName" [Size]="22" [Solid]="IsActive(module)" />
            } @else {
                <i [class]="module.Icon" aria-hidden="true"></i>
            }
            <span class="agu-bottom-tabs__label">{{ LabelOf(module) }}</span>
        </button>
    }
</nav>
